





















































































































































































































































































































import Vue from "vue";
import { RequestService } from "@/services";
import data from "@/services/data";
import PnetTable from '@previnet/vue-table';
import ComboBox from "@/components/ComboBox.vue";
import { PnetDatePicker } from "@previnet/vue-datepicker";
import moment from "moment";
import { isNil } from 'ramda';
import { it } from "vuejs-datepicker/dist/locale";
import properties, {propertyTypes} from "@/services/properties";
import { format } from "date-fns";
import Header from "@/components/Header.vue";
import categories from '../services/categories';

const requestService = new RequestService();
const handleResponse = (response: Response) => {
  if (!response.ok) {
    // TODO handle errori
  } else {
    return response.json();
  }
};

export default Vue.extend({
  props: ['user'],
  components: {
    PnetDatePicker,
    PnetTable,
    ComboBox,
    Header,
  },
  data: function() {
    return {
      loggedUser: this.$props.user,
      codCategoriaProdotto: categories.CARDIF,
      listaProdottiCensiti: [] as any[],
      listaProdottiCensitiForTable: [] as any[],
      columns: [
        {
          label: 'Seleziona',
          field: 'isSelected',
        },
        {
          label: 'Prodotto completo',
          field: 'prodottoCompleto',
        },
        {
          label: 'Codice prodotto',
          field: 'productCode',
        },
        {
          label: 'Nome',
          field: 'nome',
          width: '300px',
        },
        {
          label: 'Emittente',
          field: 'emittente',
          sortable: false,
          width: '300px',
        },
        {
          label: 'Distributore',
          field: 'distributore',
          width: '300px',
        },
        {
          label: 'Mercato',
          field: 'mercato',
          width: '300px',
        },
        {
          label: 'Canale',
          field: 'canale',
          width: '300px',
        },
        {
          label: 'Tipo prodotto',
          field: 'tipoProdotto',
          width: '300px',
        },
        {
          label: 'Tipologia sottostanti',
          field: 'tipologiaSottostantiContratto',
          width: '300px',
        },
        {
          label: 'Edizione',
          field: 'edizione',
          width: '300px',
          //type: 'date',
          //dateInputFormat: 'dd/MM/yyyy',
          //dateOutputFormat: 'dd/MM/yyyy',
          sortFn: function (x: any, y: any, col: any, rowX: any, rowY: any) {
            x = (x == 'n.d.') ? x : x.substring(6, 10) + x.substring(3, 5) + x.substring(0, 2);
            y = (y == 'n.d.') ? y : y.substring(6, 10) + y.substring(3, 5) + y.substring(0, 2);
          
            return (x < y ? -1 : (x > y ? 1 : 0)); -1
          },
        },
        {
          label: 'Prodotto in commercio',
          field: 'prodottoInCommercio',
          width: '300px',
        },
        {
          label: 'Inizio Commercializzazione',
          field: 'inizioCommercializzazione',
          width: '300px',
          //type: 'date',
          //dateInputFormat: 'dd/MM/yyyy',
          //dateOutputFormat: 'dd/MM/yyyy',
          sortFn: function (x: any, y: any, col: any, rowX: any, rowY: any) {
            x = (x == 'n.d.') ? x : x.substring(6, 10) + x.substring(3, 5) + x.substring(0, 2);
            y = (y == 'n.d.') ? y : y.substring(6, 10) + y.substring(3, 5) + y.substring(0, 2);

            return (x < y ? -1 : (x > y ? 1 : 0)); -1
          },
        },
        {
          label: 'Fine Commercializzazione',
          field: 'fineCommercializzazione',
          width: '300px',
          //type: 'date',
          //dateInputFormat: 'dd/MM/yyyy',
          //dateOutputFormat: 'dd/MM/yyyy',
          sortFn: function (x: any, y: any, col: any, rowX: any, rowY: any) {
            x = (x == 'n.d.') ? x : x.substring(6, 10) + x.substring(3, 5) + x.substring(0, 2);
            y = (y == 'n.d.') ? y : y.substring(6, 10) + y.substring(3, 5) + y.substring(0, 2);

            return (x < y ? -1 : (x > y ? 1 : 0)); -1
          },
        },
        {
          label: 'Tipo Premio',
          field: 'tipoPremio',
          width: '300px',
        },
        {
          label: 'Prodotto collegato PIC/PAC',
          field: 'prodottoCollegatoPICPAC',
          width: '300px',
        },
        {
          label: 'Codice prodotto collegato PIC/PAC',
          field: 'codiceProdottoCollegatoPICPAC',
          width: '300px',
        },
        {
          label: 'Relazione con prodotto collegato PIC/PAC',
          field: 'relazioneConProdottoCollegatoPICPAC',
          width: '300px',
        },
        {
          label: 'Orizzonte temporale suggerito KID (anni)',
          field: 'orizzonteTemporaleSuggeritoKID',
          width: '300px',
        },
        {
          label: 'Tipologia Duration',
          field: 'tipologiaDuration',
          width: '300px',
        },
        {
          label: 'Data Scadenza',
          field: 'dataScadenza',
          width: '300px',
          sortFn: function (x: any, y: any, col: any, rowX: any, rowY: any) {
            x = (x == 'n.d.') ? x : x.substring(6, 10) + x.substring(3, 5) + x.substring(0, 2);
            y = (y == 'n.d.') ? y : y.substring(6, 10) + y.substring(3, 5) + y.substring(0, 2);

            return (x < y ? -1 : (x > y ? 1 : 0)); -1
          },
        },        
        {
          label: 'Importo minimo del premio',
          field: 'importoMinimoDelPremio',
          width: '300px',
        },
        {
          label: 'Importo massimo del premio',
          field: 'importoMassimoDelPremio',
          width: '300px',
        },
        {
          label: 'Retrocessione al distributore Upfront Fee(%)',
          field: 'retrocessioneUpfront',
          width: '300px',
        },
        {
          label: 'Retrocessione al distributore Gestione Separata(%)',
          field: 'retrocessioneGestSep',
          width: '300px',
        },
        {
          label: 'Retrocessione al distributore Ramo III(%)',
          field: 'retrocessioneRamIII',
          width: '300px',
        },
        {
          label: 'GS Weight Min(%)',
          field: 'gsWeightMin',
          width: '300px',
        },
        {
          label: 'GS Weight Max(%)',
          field: 'gsWeightMax',
          width: '300px',
        },
        {
          label: 'Tipologia calcolo Bonus Ingresso',
          field: 'tipoCalcoloBonusIngresso',
          width: '300px',
        },
        {
          label: 'Bonus Ingresso',
          field: 'bonusIngresso',
          width: '300px',
        },
        {
          label: 'Tipologia calcolo Bonus Fedeltà',
          field: 'tipoCalcoloBonusFedelta',
          width: '300px',
        },
        {
          label: 'Bonus Fedeltà',
          field: 'bonusFedelta',
          width: '300px',
        },
        {
          label: 'Spese Amministrative Apertura Contratto(€)',
          field: 'speseAmmApertura',
          width: '300px',
        },
        {
          label: 'Spese Amministrative Versamento PAC(€)',
          field: 'speseAmmVersamento',
          width: '300px',
        },
        {
          label: 'Tipologia Upfront Fee',
          field: 'tipoUpfrontFee',
          width: '300px',
        },
        {
          label: 'Upfront Fee Range',
          field: 'upfrontFee',
          width: '300px',
        },
        {
          label: 'Tipologia Commissione Gestione Separata',
          field: 'tipoCommGestioneSeparata',
          width: '300px',
        },
        {
          label: 'Commissione Gestione Separata',
          field: 'commGestioneSeparata',
          width: '300px',
        },
        {
          label: 'Tipologia Commissione Fondi Interni Azionari',
          field: 'tipoCommFIAz',
          width: '300px',
        },
        {
          label: 'Commissione Fondi Interni Azionari',
          field: 'commFIAz',
          width: '300px',
        },
        {
          label: 'Tipologia Commissione Fondi Interni Obbligazionari',
          field: 'tipoCommFIObbl',
          width: '300px',
        },
        {
          label: 'Commissione Fondi Interni Obbligazionari',
          field: 'commFIObbl',
          width: '300px',
        },
        {
          label: 'Tipologia Commissione Fondi Interni Bilanciati',
          field: 'tipoCommFIBil',
          width: '300px',
        },
        {
          label: 'Commissione Fondi Interni Bilanciati',
          field: 'commFIBil',
          width: '300px',
        },
        {
          label: 'Tipologia Commissione Fondi Interni Flessibili',
          field: 'tipoCommFIFle',
          width: '300px',
        },
        {
          label: 'Commissione Fondi Interni Flessibili',
          field: 'commFIFle',
          width: '300px',
        },
        {
          label: 'Tipologia Commissione Fondi Interni Monetari',
          field: 'tipoCommFIMon',
          width: '300px',
        },
        {
          label: 'Commissione Fondi Interni Monetari',
          field: 'commFIMon',
          width: '300px',
        },
        {
          label: 'Tipologia Commissione OICR',
          field: 'tipoCommOICR',
          width: '300px',
        },
        {
          label: 'Commissione OICR Azionari',
          field: 'commOICRAz',
          width: '300px',
        },
        {
          label: 'Commissione OICR Obbligazionari',
          field: 'commOICRObbl',
          width: '300px',
        },
        {
          label: 'Commissione OICR Bilanciati',
          field: 'commOICRBil',
          width: '300px',
        },
        {
          label: 'Commissione OICR Flessibili',
          field: 'commOICRFle',
          width: '300px',
        },
        {
          label: 'Commissione OICR Monetari',
          field: 'commOICRMon',
          width: '300px',
        },
        {
          label: 'Commissioni Overperformance',
          field: 'commOverperformance',
          width: '300px',
        },
        {
          label: 'Costo garanzia caso morte Ramo III (%)',
          field: 'costoGarCasoMorteRamo3',
          width: '300px',
        },
        {
          label: 'Applicazione Commissioni di uscita',
          field: 'applCommUscita',
          width: '300px',
        },
        {
          label: 'Commissioni di uscita (%)',
          field: 'commUscita',
          width: '300px',
        },
        {
          label: 'KID',
          field: 'kid',
          width: '300px',
        },
        {
          label: 'Scenario KID - stress',
          field: 'kidStress',
          width: '300px',
        },
        {
          label: 'Scenario KID - sfavorevole',
          field: 'kidSfavorevole',
          width: '300px',
        },
        {
          label: 'Scenario KID - Moderato',
          field: 'kidModerato',
          width: '300px',
        },
        {
          label: 'Scenario KID - favorevole',
          field: 'kidFavorevole',
          width: '300px',
        },
        {
          label: 'Scenario KID - Caso morte (o evento assicurato)',
          field: 'kidMorte',
          width: '300px',
        },
        {
          label: 'GKID',
          field: 'gkid',
          width: '300px',
        },
        {
          label: 'Note',
          field: 'campoNote',
          width: '300px',
        },
      ],
      filtroRicerca: {
        nome: undefined,
        emittente: undefined,
        tipoProdotto: undefined,
        prodottoInCommercio: null,
        inizioCommercializzazioneDaDate: Date,
        inizioCommercializzazioneADate: Date,
        fineCommercializzazioneDaDate: Date,
        fineCommercializzazioneADate: Date,
        inizioCommercializzazioneDa: String,
        inizioCommercializzazioneA: String,
        fineCommercializzazioneDa: String,
        fineCommercializzazioneA: String,
        prodottoCompleto: null,
      },
      operationToConfirm: "",
      msgError: "",
      msgSuccess: "",
      msgConfirmOperation: "",
      it,
      ...data,
      ...properties,
    };
  },

  methods: {
    retrieveProductsList: async function() {
      const vm = this as any;
      vm.$loadingService.startLoading("loading");

      vm.listaProdottiCensiti = []; //clean
      vm.listaProdottiCensitiForTable = []; //clean

      vm.setDatePropertiesValue();

      const serviceCallReturnValue = await requestService.getProductsList(vm.filtroRicerca,vm.codCategoriaProdotto)
        .then(handleResponse)
        .then((result: any) => {
          vm.listaProdottiCensiti = result;

          let i;
          for (i = 0; i < vm.listaProdottiCensiti.length; i++) {
            if (vm.listaProdottiCensiti[i].properties[0] != undefined) {
              vm.listaProdottiCensitiForTable.push({'isSelected': false,
                'prodottoCompleto': vm.listaProdottiCensiti[i].completed,
                'productId': vm.listaProdottiCensiti[i].productId,
                'productCode': vm.listaProdottiCensiti[i].productCode,
                'nome': vm.listaProdottiCensiti[i].properties[0].value,
                'emittente': vm.stringify(vm.listaProdottiCensiti[i].properties[1].value),
                'distributore': vm.stringify(vm.listaProdottiCensiti[i].properties[2].value),
                'mercato': vm.stringify(vm.listaProdottiCensiti[i].properties[3].value),
                'canale': vm.stringify(vm.listaProdottiCensiti[i].properties[5].value),
                'tipoProdotto': vm.stringify(vm.listaProdottiCensiti[i].properties[6].value),
                'tipologiaSottostantiContratto': vm.stringify(vm.listaProdottiCensiti[i].properties[7].value),
                'edizione': vm.stringify(vm.listaProdottiCensiti[i].properties[8].value),
                'prodottoInCommercio': vm.stringify(vm.listaProdottiCensiti[i].properties[9].value),
                'inizioCommercializzazione': vm.stringify(vm.listaProdottiCensiti[i].properties[10].value),
                'fineCommercializzazione': vm.stringify(vm.listaProdottiCensiti[i].properties[11].value),
                'tipoPremio': vm.stringify(vm.listaProdottiCensiti[i].properties[12].value),
                'prodottoCollegatoPICPAC': vm.stringify(vm.listaProdottiCensiti[i].properties[13].value),
                'codiceProdottoCollegatoPICPAC': vm.stringify(vm.listaProdottiCensiti[i].properties[14].value),
                'relazioneConProdottoCollegatoPICPAC': vm.stringify(vm.listaProdottiCensiti[i].properties[15].value),
                'orizzonteTemporaleSuggeritoKID': vm.stringify(vm.listaProdottiCensiti[i].properties[16].value),
                'tipologiaDuration': vm.stringify(vm.listaProdottiCensiti[i].properties[17].value),
                'dataScadenza': vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[18]),
                'importoMinimoDelPremio': vm.stringify(vm.listaProdottiCensiti[i].properties[19].value),
                'importoMassimoDelPremio': vm.stringify(vm.listaProdottiCensiti[i].properties[20].value),
                'retrocessioneUpfront': vm.stringify(vm.listaProdottiCensiti[i].properties[21].value),
                'retrocessioneGestSep': vm.stringify(vm.listaProdottiCensiti[i].properties[22].value),
                'retrocessioneRamIII': vm.stringify(vm.listaProdottiCensiti[i].properties[23].value),
                'gsWeightMin': vm.stringify(vm.listaProdottiCensiti[i].properties[24].value),
                'gsWeightMax': vm.stringify(vm.listaProdottiCensiti[i].properties[25].value),
                'tipoCalcoloBonusIngresso': vm.stringify(vm.listaProdottiCensiti[i].properties[26].value),
                'bonusIngresso': vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[27]),
                'tipoCalcoloBonusFedelta': vm.stringify(vm.listaProdottiCensiti[i].properties[28].value),
                'bonusFedelta': vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[29]),
                'speseAmmApertura': vm.stringify(vm.listaProdottiCensiti[i].properties[30].value),
                'speseAmmVersamento': vm.stringify(vm.listaProdottiCensiti[i].properties[31].value),
                'tipoUpfrontFee': vm.stringify(vm.listaProdottiCensiti[i].properties[32].value),
                'upfrontFee': vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[33]),
                'tipoCommGestioneSeparata': vm.stringify(vm.listaProdottiCensiti[i].properties[34].value),
                'commGestioneSeparata': vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[35]),
                'tipoCommFIAz': vm.stringify(vm.listaProdottiCensiti[i].properties[36].value),
                'tipoCommFIObbl': vm.stringify(vm.listaProdottiCensiti[i].properties[37].value),
                'tipoCommFIBil': vm.stringify(vm.listaProdottiCensiti[i].properties[38].value),
                'tipoCommFIFle': vm.stringify(vm.listaProdottiCensiti[i].properties[39].value),
                'tipoCommFIMon': vm.stringify(vm.listaProdottiCensiti[i].properties[40].value),
                'commFIAz': vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[41]),
                'commFIObbl': vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[42]),
                'commFIBil': vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[43]),
                'commFIFle': vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[44]),
                'commFIMon': vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[45]),
                'tipoCommOICR': vm.stringify(vm.listaProdottiCensiti[i].properties[46].value),
                'commOICRAz': vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[47]),
                'commOICRObbl': vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[48]),
                'commOICRBil': vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[49]),
                'commOICRFle': vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[50]),
                'commOICRMon': vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[51]),
                'commOverperformance': vm.stringify(vm.listaProdottiCensiti[i].properties[52].value),
                'costoGarCasoMorteRamo3': vm.stringify(vm.listaProdottiCensiti[i].properties[53].value),
                'applCommUscita': vm.stringify(vm.listaProdottiCensiti[i].properties[54].value),
                'commUscita': vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[55]),
                'kid': vm.stringify(vm.listaProdottiCensiti[i].properties[56].value),
                'kidStress': vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[57]),
                'kidSfavorevole': vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[58]),
                'kidModerato': vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[59]),
                'kidFavorevole': vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[60]),
                'kidMorte': vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[61]),
                'gkid': vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[62]),
                'campoNote': vm.stringify(vm.listaProdottiCensiti[i].properties[63].value),
              });
            }
          }

          return null;
        })
        .catch(function(e) {
          vm.openModalError("Errore generico");
        });

      vm.$loadingService.stopLoading("loading");
    },
    inizializzaFiltroRicerca: function() {
      const vm = this as any;
      vm.filtroRicerca.nome = undefined;
      vm.filtroRicerca.emittente = undefined;
      vm.filtroRicerca.tipoProdotto = undefined;
      vm.filtroRicerca.prodottoInCommercio = null;
      vm.filtroRicerca.inizioCommercializzazioneDaDate = undefined;
      vm.filtroRicerca.inizioCommercializzazioneADate = undefined;
      vm.filtroRicerca.fineCommercializzazioneDaDate = undefined;
      vm.filtroRicerca.fineCommercializzazioneADate = undefined;
      vm.filtroRicerca.inizioCommercializzazioneDa = undefined;
      vm.filtroRicerca.inizioCommercializzazioneA = undefined;
      vm.filtroRicerca.fineCommercializzazioneDa = undefined;
      vm.filtroRicerca.fineCommercializzazioneA = undefined;
      vm.filtroRicerca.prodottoCompleto = null;
    },    
    home: function() {
      const vm = this as any;
      vm.$router.push({ name: 'home', params: {user: vm.loggedUser}});
    },
    stringify: function(value: string) {
      if (value == undefined ||
          value == null) {
        return "";
      }

      return value;
    },
    setIsSelected: function(index: number) {
      const vm = this as any;
      vm.listaProdottiCensitiForTable[index].isSelected = !vm.listaProdottiCensitiForTable[index].isSelected;
    },
    isCompleted: function(index: number) {
      const vm = this as any;
      return vm.listaProdottiCensitiForTable[index].prodottoCompleto ? "Sì" : "No";
    },
    formatDate: function(data: Date | string) {
      if (typeof data === "string" || isNil(data)) {
        return "";
      }

      return format(data, "dd/MM/yyyy");
    },
    setDatePropertiesValue: function() {
      const vm = this as any;

      vm.filtroRicerca.inizioCommercializzazioneDa = vm.formatDate(vm.filtroRicerca.inizioCommercializzazioneDaDate);
      vm.filtroRicerca.inizioCommercializzazioneA = vm.formatDate(vm.filtroRicerca.inizioCommercializzazioneADate);
      vm.filtroRicerca.fineCommercializzazioneDa = vm.formatDate(vm.filtroRicerca.fineCommercializzazioneDaDate);
      vm.filtroRicerca.fineCommercializzazioneA = vm.formatDate(vm.filtroRicerca.fineCommercializzazioneADate);
    },
    exportCSV: async function() {
      const vm = this as any;
      vm.startLoading();

      const productIdsFilter = [] as any;
      let i;
      for (i = 0; i < vm.listaProdottiCensitiForTable.length; i++) {
        if (vm.listaProdottiCensitiForTable[i].isSelected) {
          productIdsFilter.push(vm.listaProdottiCensitiForTable[i].productId);
        }
      }

      let contentType = '';
      let csvName = '';
      const filtro = vm.filtroRicerca;
      filtro.ids = productIdsFilter;
      const serviceCallReturnValue = await requestService
        .extractCSV(filtro)
        .then((response: any) => {
          const headerContentType = response.headers.get("content-type");
          contentType = headerContentType !== null ? headerContentType : 'application/csv';
          return response.blob();
        })
        .then((blob: any) => {
          csvName = 'product-export.csv';          
          vm.downloadDocFromBlob(blob, csvName, contentType);
        })
        .catch(() => {
          vm.openModalError("Errore generico");
        })

      vm.stopLoading();
    },
    downloadDocFromBlob(blob: any, name: string, contentType: string) {
      const newBlob = new Blob([blob], { type: contentType });

      // MS Edge and IE don't allow using a blob object directly as link href, instead it is necessary to use msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob, name);
      } else {
        // For other browsers: create a link pointing to the ObjectURL containing the blob.
        const objUrl = window.URL.createObjectURL(newBlob);

        const link = document.createElement('a');
        link.href = objUrl;
        link.target = '_blank';
        link.download = name;
        link.click();

        // For Firefox it is necessary to delay revoking the ObjectURL.
        setTimeout(() => { window.URL.revokeObjectURL(objUrl); }, 250);
      }
    },
    modifyProduct: async function() {
      const vm = this as any;

      const productIdsFilter = [] as any;
      let i;
      for (i = 0; i < vm.listaProdottiCensitiForTable.length; i++) {
        if (vm.listaProdottiCensitiForTable[i].isSelected) {
          productIdsFilter.push(vm.listaProdottiCensitiForTable[i].productId);
        }
      }

      let productIdToModify = "";
      if (productIdsFilter.length != 1) {
        vm.openModalError("Selezionare un solo prodotto da modificare.");
      } else {
        productIdToModify = productIdsFilter[0];
        vm.$router.push({ name: 'censimento-prodotti', params: {user: vm.loggedUser, productId: productIdToModify}});
      }
    },
    confirmDuplicateProduct() {
      const vm = this as any;

      vm.operationToConfirm = "DUPLICATE";
      vm.openModalConfirmOperation("Si conferma di voler clonare il prodotto?");
    },    
    duplicateProduct: async function() {
      const vm = this as any;

      const productIdsFilter = [] as any;
      let i;
      for (i = 0; i < vm.listaProdottiCensitiForTable.length; i++) {
        if (vm.listaProdottiCensitiForTable[i].isSelected) {
          productIdsFilter.push(vm.listaProdottiCensitiForTable[i].productId);
        }
      }

      let productIdToDuplicate = "";
      if (productIdsFilter.length != 1) {
        vm.openModalError("Selezionare un solo prodotto da duplicare.");
      } else {
        productIdToDuplicate = productIdsFilter[0];

        vm.startLoading();

        const serviceCallReturnValue = await requestService
          .duplicateProduct({productId : productIdToDuplicate})
          .then(handleResponse)
          .then((result: any) => {
            vm.stopLoading();
            vm.openModalSuccess("Duplicazione prodotto avvenuta con successo (productCode = " + result.productCode + ")");
            vm.retrieveProductsList();
            return null;
          })
          .catch(() => {
            vm.openModalError("Errore generico");
          })
      }
    },
    confirmDeleteProductsList() {
      const vm = this as any;

      vm.operationToConfirm = "DELETE";
      vm.openModalConfirmOperation("Si conferma di voler eliminare il prodotto?");
    },
    deleteProductsList: async function() {
      const vm = this as any;

      const productIdsFilter = [] as any;
      let i;
      for (i = 0; i < vm.listaProdottiCensitiForTable.length; i++) {
        if (vm.listaProdottiCensitiForTable[i].isSelected) {
          productIdsFilter.push(vm.listaProdottiCensitiForTable[i].productId);
        }
      }

      vm.startLoading();

      const serviceCallReturnValue = await requestService.deleteProductsList({ids : productIdsFilter})
        .then(handleResponse)
        .then((result: any) => {
          vm.stopLoading();
          vm.openModalSuccess("Eliminazione prodotti avvenuta con successo.");
          vm.retrieveProductsList();
          return null;
        })
        .catch(() => {
          vm.openModalError("Errore generico");
        })
    },
    printVersatileValues(property: any) {
      const vm = this as any;

      let printableValue = "";
      printableValue = "";
      if (property.type == propertyTypes.RANGE) {
        property.rangeValues.forEach(function(item: any) {
          printableValue += "da " + vm.stringify(item.from) + " a " + vm.stringify(item.to) + "; ";
        });
      } else if (property.type == propertyTypes.NUMBER_RANGE) {
        if (property.rangeValues) {
          property.rangeValues.forEach(function(item: any) {
            printableValue += "da " + vm.stringify(item.from) + " a " + vm.stringify(item.to) + " -> " + vm.stringify(item.value) + "; ";
          });
        }
      } else if (property.type == propertyTypes.TIME_RANGE) {
        if (property.rangeValues) {
          property.rangeValues.forEach(function(item: any) {
            printableValue += "da " + vm.stringify(item.from) + " a " + vm.stringify(item.to) + " -> " + vm.stringify(item.value) + "; ";
          });
        }
      } else if (property.type == propertyTypes.TIME_NUMBER_RANGE) {
        if (property.rangeValues) {
          property.rangeValues.forEach(function(item: any) {
            printableValue += "da " + vm.stringify(item.from) + " a " + vm.stringify(item.to);
            if (item.rangeValues) {
              item.rangeValues.forEach(function(itemL2: any) {
                printableValue += ">> da " + vm.stringify(itemL2.from) + " a " + vm.stringify(itemL2.to) + " -> " + vm.stringify(itemL2.value) + "; ";
              });
            }
          });
        }
      } else if (property.type == propertyTypes.KID) {
        if (property.rangeValues) {
          property.rangeValues.forEach(function(item: any) {
            printableValue += "da " + vm.stringify(item.from) + " a " + vm.stringify(item.to) + "; ";
          });
        }
      } else if (property.type == propertyTypes.GKID) {
        if (property.gkid) {
          printableValue += "Costi del prodotto: "
          printableValue += "da " + vm.stringify(property.gkid.costs[0].from) + " a " + vm.stringify(property.gkid.costs[0].to) + "; ";
          printableValue += "da " + vm.stringify(property.gkid.costs[1].from) + " a " + vm.stringify(property.gkid.costs[1].to) + "; ";
          printableValue += "da " + vm.stringify(property.gkid.costs[2].from) + " a " + vm.stringify(property.gkid.costs[2].to) + "; ";
          printableValue += "Fascia di rischio: "
          printableValue += "da " + vm.stringify(property.gkid.risk.from) + " a " + vm.stringify(property.gkid.risk.to);
        }
      } else {
        printableValue = vm.stringify(property.value);
      }

      return printableValue;
    },
    openModalSuccess(msg: string) {
      const vm = this as any;
      vm.msgSuccess = msg;
      vm.$bvModal.show("modal-success");
    },
    closeModalSuccess() {
      const vm = this as any;
      vm.$bvModal.hide("modal-success");
    },
    onClickReturnSuccess() {
      const vm = this as any;
      vm.closeModalSuccess();
    },
    openModalError(msg: string) {
      const vm = this as any;
      vm.msgError = msg;
      vm.$bvModal.show("modal-error");
    },
    closeModalError() {
      const vm = this as any;
      vm.$bvModal.hide("modal-error");
    },
    onClickReturnError() {
      const vm = this as any;
      vm.closeModalError();
    },
    openModalConfirmOperation(msg: string) {
      const vm = this as any;
      vm.msgConfirmOperation = msg;
      vm.$bvModal.show("modal-confirm-operation");
    },
    closeModalConfirmOperation() {
      const vm = this as any;
      vm.$bvModal.hide("modal-confirm-operation");
    },
    onClickReturnConfirmOperation() {
      const vm = this as any;
      if (vm.operationToConfirm == "DELETE") {
        vm.deleteProductsList();
      } else if (vm.operationToConfirm == "DUPLICATE") {
        vm.duplicateProduct();
      }
      vm.operationToConfirm == "";
      vm.closeModalConfirmOperation();
    },    
    startLoading() {
      const vm = this as any;
      vm.$loadingService.startLoading("loading");
    },
    stopLoading() {
      const vm = this as any;
      vm.$loadingService.stopLoading("loading");
    },
    getUser: async function() {
      const vm = this as any;
      const serviceCallReturnValue = await requestService.getUser()
        .then(handleResponse)
        .then((result: any) => {
          vm.loggedUser = result;
        });
    },
  },
  created() {
    if (this.$props.user == undefined) {
      this.getUser();
    }
    this.inizializzaFiltroRicerca();
    //this.retrieveProductsList();
  }
});
